import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import throttle from 'lodash/throttle';
import * as queryString from 'query-string';
import Select from 'components/common/Select';
import LoadingSpinner from 'components/common/LoadingSpinner';
import DownloadModule from 'components/common/DownloadModule';
import { roundNumber } from 'utils/general';
import { setSelectOptions, parseRegions } from 'utils/data';
import isEqual from 'lodash/isEqual';
import LegendTraffic from 'components/country-profiles/show/LegendTraffic';

import {
  DEFAULT_SELECT_CATEGORY_OPTION,
  DEFAULT_SELECT_GROUP_OPTION,
  MIN_LIMIT,
  MAX_LIMIT,
  SCORE_COLORS
} from 'constants/data';


function getColorTextScore(score) {
  let color;
  const value = roundNumber(score);

  switch (true) {
    case (value < 30): { color = '#fff'; break; }
    case (value < 45): { color = '#000'; break; }
    case (value < 60): { color = '#000'; break; }
    case (value < 75): { color = '#000'; break; }
    case (value <= 100): { color = '#fff'; break; }
    default: color = '#000000';
  }

  return color;
}
function getBackgroundScore(score) {
  let color;
  const value = roundNumber(score);

  switch (true) {

    case (value < 30): { color = SCORE_COLORS[4]; break; }
    case (value < 45): { color = SCORE_COLORS[3]; break; }
    case (value < 60): { color = SCORE_COLORS[2]; break; }
    case (value < 75): { color = SCORE_COLORS[1]; break; }
    case (value <= 100): { color = SCORE_COLORS[0]; break; }
    default: color = SCORE_COLORS[5];
  }

  return color;
}

class IssueTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      indicatorActive: false,
      subcategoryActive: false,
      scoreValues: {
        min: -1,
        max: -1,
        average: -1
      }
    };

    this.regionSelectorOptions = [];
    this.categorySelectorOptions = [];
    this.subCategorySelectorOptions = [];
    this.indicatorsSelectorOptions = [];

    // Bindings
    this.handleSort = this.handleSort.bind(this);
    this.onScrollLegend = throttle(this.onScrollLegend, 40).bind(this);
  }

  componentWillMount() {
    const { filters, options } = this.props;
    this.props.getFilters();

    if (filters.category !== '') {
      this.props.getCountrySectors(filters);
    } else {
      this.props.getCountries(this.props.filters.years);
    }

    if (
      filters.category !== '' &&
      filters.category !== DEFAULT_SELECT_CATEGORY_OPTION.id
    ) {
      this.props.getSubcategories(filters.category);
    }
    if (filters.subcategory !== '') {
      this.props.getIndicators(filters.subcategory);
    }

    this.setState({
      subcategoryActive: filters.category !== DEFAULT_SELECT_CATEGORY_OPTION.id,
      indicatorActive: filters.subcategory !== '' && options.indicators.length
    });
  }

  componentDidMount() {
    const { filters } = this.props;
    const route = this.props.router.getCurrentLocation();
    const { pathname, search } = route;

    window.addEventListener('scroll', this.onScrollLegend);
    this.props.getActiveYears();

    if (search.length) return;
    let paramsFilter = {
      region: filters.region
    };
    if (filters.years && filters.years.length) {
      paramsFilter = { ...paramsFilter, years: filters.years.join(',') };
    }
    const filterParams = queryString.stringify(paramsFilter);

    this.props.router.replace(`${pathname}?${filterParams}`);
  }

  componentWillReceiveProps(nextProps) {
    const { options, filters } = nextProps;

    if (options.regions.length) {
      this.regionSelectorOptions = this.loadFilters(nextProps, 'region');
    }

    if (options.composites.length && options.categories.length) {
      this.categorySelectorOptions = this.loadFilters(nextProps, 'category');

      const categoryId = filters.category
        ? filters.category
        : options.composites[0].id;
      this.updateScoreValues(options, categoryId, 'category');
    }

    if (options.subcategories.length) {
      this.subCategorySelectorOptions = this.loadFilters(
        nextProps,
        'subcategory'
      );

      const subcategoryId = filters.subcategory || null;
      this.updateScoreValues(options, subcategoryId, 'subcategory');
    }

    if (options.indicators.length) {
      this.indicatorsSelectorOptions = this.loadFilters(nextProps, 'indicator');
      const indicatorId = filters.indicator || null;
      this.updateScoreValues(options, indicatorId, 'indicator');
    }
    if (!this.props.mapCountries || !this.props.mapCountries.length) {
      this.props.getCountries();
    }
    if (!isEqual(this.props.filters, filters)) {
      if (filters.category !== DEFAULT_SELECT_CATEGORY_OPTION.id) {
        this.props.getCountrySectors(filters);
      }
    }

    this.setState({
      subcategoryActive: filters.category !== DEFAULT_SELECT_CATEGORY_OPTION.id,
      indicatorActive: filters.subcategory !== '' && options.indicators.length
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScrollLegend);
  }

  onScrollLegend() {
    const generalInfo = document.getElementsByClassName('data-ranking')[0];
    const legend = document.getElementsByClassName('c-legend-traffic')[0];
    const containerHeight = generalInfo.offsetHeight;
    const containerPosition = generalInfo.getBoundingClientRect().top;

    if (containerPosition + containerHeight - legend.offsetHeight - 100 <= 0) {
      legend.style.position = 'absolute';
      legend.style.top = 'auto';
      legend.style.bottom = '0';
    } else if (containerPosition <= 60) {
      legend.style.position = 'fixed';
      legend.style.top = '100px';
      legend.style.bottom = 'auto';
    } else {
      legend.style.position = 'absolute';
      legend.style.top = '60px';
      legend.style.bottom = 'auto';
    }
  }
  getSingleScoreColSpan() {
    return Math.floor(6 / this.props.filters.years.length);
  }
  getScoresHeader(sortArrows) {
    if (!this.props.filters.years.length) return null;
    const number = this.getSingleScoreColSpan();
    return this.props.filters.years.map(el => <div key={el} className={`column small-${number} -score`}>
      <p className="-center ranking-header-title -bold -score -sortable" data-value={`score${el}`} onClick={this.handleSort}>
        {`${el} Score`}
        <span
          className={`sort-arrows ${this.props.sort.type === 'score' && sortArrows}`}
        ></span>
      </p>
    </div>);
  }
  getScoresContent(item) {
    if (!this.props.filters.years.length) return null;
    const number = this.getSingleScoreColSpan();
    return this.props.filters.years.map(el => {
      const yearScore = item[`score${el}`];
      return (<div key={el} className={`column small-${number}`}>
        <p className="-center score">
          <span style={{ display: 'block', backgroundColor: getBackgroundScore(yearScore), borderRadius: '4px', width: '100%', maxWidth: '120px', margin: '0 auto' }}>
            <span style={{ padding: '5px 7px', color: getColorTextScore(yearScore), borderRadius: 25, fontWeight: 'bold' }}>{yearScore !== null ? roundNumber(yearScore) : '.'}</span>
          </span>
        </p>
      </div>);
    });
  }
  getContentTable() {
    const sortArrows = this.props.sort && `-${this.props.sort.direction}`;

    if (this.props.loading) return <LoadingSpinner />;
    return (
      <div className="c-data-list">
        <ul className="ranking-list">
          <li className="row ranking-header">

            <div className="column small-6-country-name" onClick={this.handleSort} data-value="name">
              <p className="-bold ranking-header-title -sortable">
                Country
                <span className={`sort-arrows ${this.props.sort.type === 'name' && sortArrows}`}></span>
              </p>
            </div>

           {this.getScoresHeader(sortArrows)}
          </li>
          {this.props.filteredData.map((item, index) => (
            <li key={index} className={`row ranking-item  ${item.score === null ? '-not-covered' : ''}`}>
              <div className="column small-6">
                <p className="country-sector">{item.name}</p>
              </div>

             {this.getScoresContent(item)}
              <div className="column small-12 data-list-spacer"></div>
            </li>
          ))}
          <li></li>
        </ul>
      </div>
    );
  }

  getLabelPosition(value) {
    if (value >= MIN_LIMIT && value <= MAX_LIMIT) {
      return `${value}%`;
    }

    return value > MAX_LIMIT ? `${MAX_LIMIT}%` : `${MIN_LIMIT}%`;
  }

  updateScoreValues(props, categoryId = null, type) {
    let scoreValues = {};

    if (categoryId === null) return;

    if (type === 'category') {
      const { composites, categories } = props;
      const { min, max, average } =
        categoryId === DEFAULT_SELECT_CATEGORY_OPTION.id
          ? composites[0]
          : categories[categoryId - 1];
      scoreValues = {
        min: +min,
        max: +max,
        average: +average
      };
    }

    if (type === 'subcategory') {
      const { subcategories } = props;
      const { min, max, average } = subcategories.find(
        (sc) => sc.id === categoryId
      );
      scoreValues = {
        min: +min,
        max: +max,
        average: +average
      };
    }

    if (type === 'indicator') {
      const { indicators } = props;
      const { min, max, average } = indicators.find(
        (sc) => sc.id === categoryId
      );
      scoreValues = {
        min: +min,
        max: +max,
        average: +average
      };
    }

    this.setState({ scoreValues });
  }

  loadFilters({ options }, type) {
    let selectorOptions = [];

    if (type === 'region') {
      const { regions } = options;
      selectorOptions = [
        ...[DEFAULT_SELECT_GROUP_OPTION],
        ...parseRegions(regions)
      ];
    }

    if (type === 'category') {
      const { composites, categories } = options;
      selectorOptions = setSelectOptions([composites[0], ...categories]);
    }

    if (type === 'subcategory') {
      const { subcategories } = options;
      selectorOptions = setSelectOptions(subcategories);
    }

    if (type === 'indicator') {
      const { indicators } = options;
      selectorOptions = setSelectOptions(indicators);
    }

    return selectorOptions;
  }

  handleParamChange(param, option) {
    const { filters, router } = this.props;
    const { category, subcategory, region, indicator, years } = filters;
    const route = router.getCurrentLocation();
    const { pathname } = route;
    let paramsFilters = { };
    if (param === 'region') {
      paramsFilters = {
        region: option.value
      };
    }

    if (param === 'category') {
      paramsFilters = {
        region,
        category:
          option.value !== DEFAULT_SELECT_CATEGORY_OPTION.id
            ? option.value
            : undefined
      };

      this.setState({
        subcategoryActive:
          option.value !== '' &&
          option.value !== DEFAULT_SELECT_CATEGORY_OPTION.id,
        indicatorActive: false
      });

      if (option.value !== DEFAULT_SELECT_CATEGORY_OPTION.id) {
        this.props.getSubcategories(option.value);
      }
    }

    if (param === 'subcategory') {
      paramsFilters = {
        region,
        category,
        subcategory: option.value
      };

      this.setState({ indicatorActive: true });
      this.props.getIndicators(option.value);
    }

    if (param === 'indicator') {
      paramsFilters = {
        region,
        category,
        subcategory,
        indicator: option.value
      };
    }
    if (param === 'years') {
      paramsFilters = {
        ...paramsFilters,
        region,
        category,
        subcategory,
        indicator,
        years: option
      };
    } else {
      paramsFilters = {
        ...paramsFilters,
        years
      };
    }
    // remove undefined values
    const valueKeys = Object.keys(paramsFilters).filter(el => paramsFilters[el]);
    let updatedParamsFilter = {};
    valueKeys.forEach(el => {
      updatedParamsFilter[el] = paramsFilters[el];
    });
    updatedParamsFilter = queryString.stringify(updatedParamsFilter);
    router.replace(`${pathname}?${updatedParamsFilter}`);
    this.updateScoreValues(this.props.options, option.value, param);
  }

  handleSort(e) {
    const type = e.currentTarget.dataset
      ? e.currentTarget.dataset.value
      : 'rank';
    const sort =
      type === this.props.sort.type
        ? {
          type,
          direction: this.props.sort.direction === 'asc' ? 'desc' : 'asc'
        }
        : { type, direction: 'asc' };

    this.props.setSortBy(sort.type, sort.direction);
  }

  render() {
    const { filters } = this.props;
    const { region, category, subcategory, indicator, years } = filters;
    const classNext = ['-next'];
    const yearsValueOption = years.map((el) => ({
      label: el,
      value: el
    }));
    const allYearsOptions = (this.props.activeYears || []).map((el) => ({
      label: el,
      value: el
    }));
    return (
      <div className="l-content">
        <div className="row">
          {/* TODO: Remove provisional inline style */}
          <div className="column small-12 medium-small-7 medium-4">
            <Select
              label="Country grouping"
              classOpts="group-select"
              clearable={false}
              autosize={false}
              value={region}
              placeholder={'Select a group'}
              noResultsText={'Group not found'}
              options={this.regionSelectorOptions}
              onChange={(option) => this.handleParamChange('region', option)}
            />
          </div>
          <div
            className="column small-12 medium-small-7 medium-4"
            style={{ marginBottom: '20px' }}
          >
            <Select
              classOpts="group-select"
              clearable={false}
              autosize={false}
              noResultsText={'Group not found'}
              label="Select years"
              subscript={'( min 1, max 3 )'}
              placeholder={'Select years to include'}
              value={yearsValueOption}
              options={allYearsOptions}
              multi
              onChange={(option) => {
                if (option.length < 1 || option.length > 3) return;
                this.handleParamChange('years', option.map(el => el.value).join(','));
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="column small-12 medium-small-7 medium-4 large-4">
            <Select
              label="Composite/component"
              clearable={false}
              classOpts="category-select"
              autosize={false}
              value={category || DEFAULT_SELECT_CATEGORY_OPTION.id}
              placeholder={'Select a component'}
              noResultsText={'Category not found'}
              options={this.categorySelectorOptions}
              onChange={(option) => this.handleParamChange('category', option)}
            />
          </div>
          <div className="column small-12 medium-small-7 medium-4 large-4">
            <Select
              label="Subcomponent"
              classOpts={`${classNext.join(' ')} subcategory-select ${
                this.state.subcategoryActive ? '' : '-disable'
              }`}
              clearable={false}
              autosize={false}
              placeholder={'Select a subcomponent'}
              noResultsText={'Subcategory not found'}
              value={subcategory}
              options={this.subCategorySelectorOptions}
              onChange={(option) =>
                this.handleParamChange('subcategory', option)
              }
            />
          </div>
          <div className="column small-12 medium-small-7 medium-4 large-4">
            <Select
              label="Indicator"
              classOpts={`${classNext.join(' ')} indicator-select ${
                this.state.indicatorActive ? '' : '-disable'
              }`}
              clearable={false}
              autosize={false}
              placeholder={'Select an indicator'}
              noResultsText={'Indicator not found'}
              value={indicator}
              options={this.indicatorsSelectorOptions}
              onChange={(option) => this.handleParamChange('indicator', option)}
            />
          </div>
        </div>
        <div className="data-ranking-list">
          <LegendTraffic theme="-light" />
          <div className="row data-ranking">
            <div className="column small-12 medium-12">
              {this.getContentTable()}</div>
          </div>
        </div>
        <DownloadModule
          title="Download the Full Dataset"
          link={this.props.downloadLink}
          isLink
          isDownload
        />
      </div>
    );
  }
}

IssueTab.propTypes = {
  getCountries: PropTypes.func,
  getActiveYears: PropTypes.func,
  getFilters: PropTypes.func,
  getCountrySectors: PropTypes.func,
  getSubcategories: PropTypes.func,
  getIndicators: PropTypes.func,
  setSortBy: PropTypes.func,
  filters: PropTypes.object,
  filteredData: PropTypes.array,
  mapCountries: PropTypes.array,
  loading: PropTypes.bool,
  options: PropTypes.object,
  sort: PropTypes.object,
  router: PropTypes.object,
  downloadLink: PropTypes.string,
  activeYears: PropTypes.array
};

export default withRouter(IssueTab);



// WEBPACK FOOTER //
// ./app/components/data/Issue.jsx